<script setup>
import { defineProps, onMounted, ref, defineEmits, defineExpose  } from "vue";
import Email from "@/components/form-fields/email/Index.vue";
import Password from "@/components/form-fields/password/Index.vue";
import { useCreateCustomerAccessToken, updateCustomerCartBuyerIdentity } from '@/hooks/shopify-hooks/api/useLoginApi';
import { _CSR_SHOP_CART_ID, _CSR_ACCESS_TOKEN, _CSP_ACCOUNT_HASH, _CSR_LOGIN_EMAIL } from '@/const/shopifyConst';
import {
	useCsrFormValidator,
} from "@/hooks/common/useCsrFormValidator";
import { useIsAccessTokenValid } from "@/hooks/shopify-hooks/useShopifyUtils.js";
import { useCustomerName, useGetPath ,useGetB2bLoginURL} from '@/hooks/shopify-hooks/useShopifyMessageEvent';
import { useDispatchGAEvent } from '@/hooks/common/useDispatchGAEvent';
import { useFailMsgBox } from "@/hooks/common/msg-box/useFailMsgBox";
import useBaseData from "@/hooks/api/useBaseData";
import { useSetStorage, useGetStorage } from '@/hooks/common/useStorage';

const emailInput = ref(null);
const passwordInput = ref(null);
const acceptsMarketing = ref(false);
const myAccountPage = ref('');
const loading = ref(false);
const resValue = ref(null);

const $emitEvents = defineEmits(["onChange"]);

// const cartId = ref(localStorage.getItem(_CSR_SHOP_CART_ID));
const cartId = ref(useGetStorage(_CSR_SHOP_CART_ID));

const { loginPath, myAccountPath, homePagePath } = useGetPath();

const props = defineProps({
    stateKey: {
        type: String,
        default: ''
    },
    currentLoginState: {
        type: String,
        default: ''
    },
    loginConfig: {
      type: Object,
      default: null
    }
});

const showError = ref(false);

onMounted(() => {
  // 已经有登录态，跳去首页
  myAccountPage.value = myAccountPath;
  // const accessToken = JSON.parse(localStorage.getItem(_CSR_ACCESS_TOKEN));
  const accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
  if (accessToken && useIsAccessTokenValid(accessToken)) {
    // window.location.href = '/content/midea-aem/us.html?wcmmode=disabled';
    const { isEdit } = useBaseData();
    // 页面不是编辑状态才跳转，编辑状态不跳转，后台在编辑模式
    if (!isEdit) {
      window.location.href = homePagePath;
      return;
    }
    
  }
})

const submitForm = () => {
  console.log('submitForm')
  useCsrFormValidator([emailInput, passwordInput]).then(res => {
    // const { email, password} = res;
    resValue.value = res;
  console.log('useCsrFormValidator',resValue.value)

    if (!acceptsMarketing.value) {
      showError.value = true;
      return;
    }
    // 进行极验校验
    window.captchaObj && window.captchaObj.showCaptcha && window.captchaObj.showCaptcha();
    // loginIn({ email, password });
  })
}
// 防止aem返回的时候带了token，导致token失效，导致登录失败陷入循环
const ReplaceToken = (url) => {
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.delete('token');
    // 同时处理 hash 中的 token 参数（如 #/path?token=xxx）
    const hashQueryIndex = urlObj.hash.indexOf('?');
    if (hashQueryIndex !== -1) {
      const hashPath = urlObj.hash.slice(0, hashQueryIndex);
      const hashParams = new URLSearchParams(urlObj.hash.slice(hashQueryIndex));
      hashParams.delete('token');
      const remainingHash = hashParams.toString();
      urlObj.hash = remainingHash ? `${hashPath}?${remainingHash}` : hashPath;
    }
    return urlObj.toString();
  } catch {
    // 兜底：url 非标准格式时，用正则移除 token 参数
    return url
      .replace(/([?&])token=[^&#]*/g, (match, separator) => separator === '?' ? '?' : '')
      .replace(/\?&/, '?')
      .replace(/\?$/, '');
  }
}
const referrerFn = () =>{
  const referrer = document.referrer;
  const isSameDomain = referrer?.startsWith(location.origin);
  if(!referrer || referrer.includes(loginPath) || !isSameDomain) {
    return true;
  }
  return false
}
const loginIn = async (validateParams) => {
  const { email, password } = resValue.value;
  loading.value = true;
  try {
    const res = await useCreateCustomerAccessToken({
      email,
      password
    },validateParams,props.loginConfig);
    if (res?.customerAccessToken?.accessToken) {
      // localStorage.setItem(_CSR_ACCESS_TOKEN, JSON.stringify(res?.customerAccessToken));
      useSetStorage(_CSR_ACCESS_TOKEN, res?.customerAccessToken);
      useSetStorage(_CSR_LOGIN_EMAIL, email);
      // 派发GA事件
      useDispatchGAEvent('__GA_SIGN_IN_CLICK__');
      const buyerIdentity = {
        customerAccessToken: res?.customerAccessToken?.accessToken,
        email: email
      }
      if (cartId.value) {
        await updateCustomerCartBuyerIdentity(buyerIdentity, cartId.value);
      }
      
      // 通知header更新用户名字
      await useCustomerName();
     
      const referrer = document.referrer;
      // 检查来源页面是否为空或包含登录页的 URL,来源页面是否和登录页同域名
      if (referrerFn()) {
        setTimeout(() => window.location.href = myAccountPage.value, 500);
      } else {
        const accountPath = new URL(myAccountPath).pathname;
        if (referrer.includes(accountPath) && sessionStorage.getItem(_CSP_ACCOUNT_HASH)) {
          const accountHash = sessionStorage.getItem(_CSP_ACCOUNT_HASH);
          sessionStorage.removeItem(_CSP_ACCOUNT_HASH);
          console.log('===back', accountHash)
          setTimeout(() => window.location.href = ReplaceToken(document.referrer + accountHash), 500);
        } else {
          setTimeout(() => window.location.href = ReplaceToken(document.referrer), 500);
        }
      }
    }
    loading.value = false;
  } catch (e) {
    if (e.message === 'Error: UNIDENTIFIED_CUSTOMER') {
      useFailMsgBox(props?.loginConfig?.signInPWPrompt || 'UNIDENTIFIED_CUSTOMER');
    }
    console.error(e);
    loading.value = false;
  }
   
}

const getB2bLoginURL = async () => {
  useGetB2bLoginURL(props.loginConfig.target);
}

const handleChange = () => {
  acceptsMarketing.value = !acceptsMarketing.value
  if (acceptsMarketing.value) {
    showError.value = false;
  }
};

// 点击注册按钮，切换到注册页面
const handleClickSign = (target) => {
  $emitEvents("onChange", target);
}

defineExpose({
  loginIn,
});

</script>

<template>
  <div class="csr-login__wrap" v-Mdloading="loading">
    <div class="csr-login__top csr-login__top--login">
      <div class="csr-login__title">
        {{ loginConfig.signInTitle }}
      </div>
     
    </div>
    <div>
      <form id="csr-shopify-login" @submit.prevent="submitForm">
        <div class="csr-login__form">
          <Email
            ref="emailInput"
            :data-conf="{ 
              label: loginConfig.signInEmailLabel, 
              placeholder: loginConfig.signInEmailPlaceholder, 
              required: true, 
              name: 'email',
              defErrorMsg: loginConfig.requiredFieldsPrompt,
              formatHint: loginConfig.emailFormatPrompt
            }" />
          <div class="csr-login__form__last-item">
            <Password
              :currentLoginState="currentLoginState"
              ref="passwordInput"
              :data-conf="{ label: loginConfig.signInPasswordLabel, placeholder: loginConfig.signInPasswordPlaceholder, defErrorMsg: loginConfig.requiredFieldsPrompt, required: true, minlength: '8',  name: 'password', restrictionHint: loginConfig.passwordSecurityPrompt }"
            ></Password>
          </div>  
          <a class="csr-login__form__password"  href="#" @click="() =>handleClickSign('Password')">{{ loginConfig.resetPWQuickLinkName }}</a>
        </div>
        <div :class="[showError ? 'csr-login__policy error': 'csr-login__policy']" v-if="loginConfig.signInTermMandatory === 'true'">
          <MdCheckbox
            :value="acceptsMarketing"
            @change="handleChange"
            :error="showError"
          >
            <span :class="[showError ? 'csr-login__policy__content error': 'csr-login__policy__content']">
              <span class="login__policy__txt" v-html="loginConfig.signInTermAgreementLabel"></span>
              <!-- {{ loginConfig.signInTermAgreementLabel }} -->
              <!-- <a :href="loginConfig.signInTermPrivacyPolicyLink" :target="loginConfig.target" class="csr-login__policy__txt" v-if="loginConfig.signInTermPrivacyPolicyLink">{{ loginConfig.signInTermPrivacyPolicyLinkText }}&nbsp;&nbsp;</a> -->
              <!-- <a :href="loginConfig.signInTermLink" :target="loginConfig.target" v-if="loginConfig.signInTermLink" class="csr-login__policy__txt">{{ loginConfig.signInTermLinkText }}</a> -->
            </span>
          </MdCheckbox>
        </div>
        <div>
          <button
          :class="loginConfig.signInB2BEnabled === 'true' ? '' : 'csr-login__btn_not_b2b'"
          class="csr-login__btn md-button-v2 md-button md-button--primary" type="submit">{{ loginConfig.signInButton }}</button>  
        </div>
      </form>
      <button class="csr-login__btn_b2b" @click="getB2bLoginURL" v-if="loginConfig.signInB2BEnabled === 'true'">{{ loginConfig.signInB2BButton }}</button>
    </div>
     <div class="csr-login__sub-title">
        {{ loginConfig.signInSubtitle }}
        <a
          class="csr-login__sub-title__btn"
          href="#"
          @click="() => handleClickSign('Register')"
        >{{ loginConfig.signUpQuickLinkName }}</a>
      </div>
  </div>
</template>